export default {
    title: 'Bring their existing setup with them',
    description: 'Already started in the activation portal? Preview their answers here. Existing Studio answers stay in place.',
    email: 'Email used in the activation portal',
    preview: 'Preview existing answers',
    loading: 'Looking up their setup…',
    source: 'Answers from {company}',
    fields: '{count} empty fields can be filled.',
    preserved: 'Existing answers are kept. The original portal remains available.',
    apply: 'Add these answers to the draft',
    applying: 'Adding answers…',
    cancel: 'Cancel preview',
    nothing: 'There are no empty fields to fill from this record.',
    failed: 'The previous setup could not be imported.',
    unavailable: 'The existing portal connection is not configured on this Studio environment. Your current setup is still available.',
    mismatch: 'We could not verify that this portal record belongs to this organization. Check the contact email and company website.',
    changed: 'This setup has changed. Close and reopen the details, then preview the import again.',
    applied: 'Existing answers added. The customer can review them before finishing setup.',
}
